import Service from '@ember/service';
import { service } from '@ember/service';

/////////////////////////////////////////////////////////////////////////////////
// assets - service for getting internal resources from the application        //
/////////////////////////////////////////////////////////////////////////////////

export default class AssetsService extends Service {
  @service logger;
  abortController = new AbortController();

  willDestroy() {
    this.abortController.abort();
  }

  getAsset(url, type) {
    return fetch(url, { headers: { 'Cache-Control': 'no-store' }, method: 'GET', signal: this.abortController.signal })
      .then((response) => {
        if (response.status !== 200) {
          throw `HTTP Request Failed: ${response.status} ${response.statusText}`;
        }
        switch (type) {
          case 'JSON':
            return response.json();
          case 'BLOB':
            return response.blob();
          case 'TEXT':
          default:
            return response.text();
        }
      })
      .catch((error) => {
        this.logger.error(`Fetch of ${url} failed: ${error}`);
        return null;
      });
  }
}
